import updateTable from './update-table'
import updateValues from './update-values'

const updateChallenges = [updateTable, updateValues]

export default updateChallenges
